var map = {
	"./Disruption Typeface/RZ_Disruption_01-Regular.woff": 8699,
	"./Flause Typeface/Flause-Regular.woff": 1607,
	"./Regalia_SS01_WIP/Regalia-WIP-RegularSS01.woff": 4620,
	"./Regalia_WIP/Regalia-WIP-Regular.woff": 8369,
	"./Tymax_Typeface/Tymex-Regular.woff": 2443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6495;